module.exports = __webpack_public_path__ + "img/anewitem-toys.a61ff747.svg";